module.exports = __webpack_public_path__ + "static/media/PlanoConta6.4a2bc52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadPlanoConta/PlanoConta6.png
// module id = 2206
// module chunks = 0